module.exports = __webpack_public_path__ + "media/crash-video.0d5e2dc3.mp4";